<ng-container *ngIf="(sharedNavEnabled$ | async) === 'true'">
  <div webu-shared-nav-scroll id="gbSharedNav" style="position: fixed; z-index: 123; transition: top 0.35s ease">
    <webu-shared-nav-wrapper [isAuthenticated]="(userState$ | async) === 'authenticated'"></webu-shared-nav-wrapper>
  </div>
</ng-container>
<div class="header-white">
  <div class="container">
    <div class="col-12">
      <div class="cit2-page-heading mt-10">
        <div class="title"></div>
        <webu-vehicle-switcher></webu-vehicle-switcher>
      </div>
    </div>
  </div>
  <webu-plan-offer-banner [linkCheck] = "'banner'"></webu-plan-offer-banner>
</div>

<div role="main">
  
  <div class="container gb-headline1 mt-4 mb-4" *ngIf="myPlanLabel">
    <span class="pr-2">
      <img [src]="'/content/dam/gmownercenter/global/resources/icons/OnStarLogo.svg' | link" alt="Bank Icon" width="50" height="50">
  </span>
  {{myPlanLabel}}</div>

  <div *ngIf="hasError" class="container">
    <ox-alert [type]="'error'">
      <div *ngIf="errorMessage">{{errorMessage}}</div>
      <div *ngIf="!errorMessage" [translate]="'my_plans_error_msg'"></div>
    </ox-alert>
  </div>
  
  <div class="mb-5">
    <div  class="container">
      <ox-grouped-alerts
        [userRole]="userRole"
        [userName]="userName"
        [paymentMethod]="paymentMethod"
        [alerts]="alerts"
        [currentPageName]="myPlanLabel">
      </ox-grouped-alerts>
    </div>

    <div *ngIf="myPlansLoaded && copyLoaded; else loadingComponent">
      <div *ngFor="let category of myPlans.categories" [ngClass]="category.type === 'INCLUDED' || category.type === 'DIGITAL_UPGRADES' ? 'bg-white' : ''">
        <div class="container">
          <webu-plan-category [category]="category" [orderIdMap]="orderIdMap"></webu-plan-category>
        </div>
      </div>

      <div *ngIf="showCancelMessage">
        <webu-cancel-plan-info [make]="make" [includeCancelFAQLink]="includeCancelFAQLink"></webu-cancel-plan-info>
      </div>

      <ng-container *ngIf="recommendedLoaded; else loadingComponent">
        <webu-recommended-offers-section *ngIf="showRecommended"
          [offers]="recommendedOffers"
          [year]= "year"
          [model]="model">
        </webu-recommended-offers-section>
      </ng-container>

    </div>
  </div>
</div>

<ng-template #loadingComponent>
  <ox-loading *ngIf="!hasError"></ox-loading>
</ng-template>
